import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportId = "bos-referral";
const reportName = `Encaminhamento dos envolvidos`
const BosReferral = ({data}) => {
  useEffect(() => {
    const values = data.slice(0,5).map(i => i.qty);
    const labels = data.slice(0,5).map(i => i.referral);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{`${reportName} ${data?.length >= 5 ? ' (TOP 5)' : ''}`}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default BosReferral;